import { handleResponse } from "@/services/handlers";
import Vue from "vue";
import {
  BACKEND_BASE_URL,
  IApprovalsUpdateStatusResponse,
  IResponseError,
  serialize,
  IApprovalsParams,
  IApprovalsService,
  IApprovalsUpdatePayload,
} from "@/services";
import { ICashOrderDTO } from "@/entities";

export class ApprovalsService implements IApprovalsService {
  async exportOrders(params: IApprovalsParams): Promise<void> {
    await Vue.$axios.post(
      `${BACKEND_BASE_URL}/api/configuration/v1/order-approvals/export`,
      params
    );
  }

  async getOrders(params: IApprovalsParams): Promise<ICashOrderDTO[] | undefined> {
    const { response, error } = await handleResponse<ICashOrderDTO[], IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/order`, {
        params,
        paramsSerializer: (p) => serialize(p),
      })
    );

    if (error) {
      return undefined;
    }

    return response?.data;
  }

  async updateOrderStatus(
    payload: IApprovalsUpdatePayload
  ): Promise<IApprovalsUpdateStatusResponse> {
    const { countryCode, orderId, ...body } = payload;
    const { response, error } = await handleResponse<
      IApprovalsUpdateStatusResponse,
      IResponseError
    >(
      Vue.$axios.patch(
        `${BACKEND_BASE_URL}/api/sol-service/v1/services/${countryCode}/orders/${orderId}/status`,
        body
      )
    );

    if (error) {
      return {
        success: false,
      };
    }

    return {
      success: response?.data?.success ?? false,
    };
  }
}
